module.exports = __webpack_public_path__ + "lp/img/send_icn-active.6fd730ff.svg";